









import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

@Component
export default class WHeading extends Mixins(WidgetMixin, TextMixin) {
  @Prop({ type: Boolean, default: false })
  underline!: boolean;

  get computedClasses() {
    return {
      "border-bottom": this.underline,
    };
  }
}
